import { Block } from '../block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { MainLayoutSidebarBlock } from './main-layout-sidebar-block.js'
import { ContentAreaBlock } from './content-area-block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

export const MainLayoutToolbarPositions = {
	none: 'None',
	before: 'Before main layout',
	insideContent: 'Inside main content',
} as const
export type MainLayoutToolbarPosition = keyof typeof MainLayoutToolbarPositions

@jsonClass('MainLayoutBlock')
export class MainLayoutBlock extends Block {
	readonly allowedChildTypes = [MainLayoutSidebarBlock, ContentAreaBlock]

	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 1,
		label: 'Toolbar position',
		options: Object.entries(MainLayoutToolbarPositions),
		isBinding: false,
	})
	toolbarPosition: MainLayoutToolbarPosition = 'before'

	constructor(init: Partial<MainLayoutBlock> = {}) {
		super()
		this.init(init)
	}

	static createNewForEditor(): Block {
		return new this({
			children: [
				MainLayoutSidebarBlock.createNewForEditor(),
				new ContentAreaBlock({ name: 'toolbar' }),
				new ContentAreaBlock({ name: 'main' }),
			],
		})
	}

	getTitleBackgroundAndBorderColor(): string {
		return '#78909c'
	}

	getTitleColor(): string {
		return 'white'
	}

	// getPreviewDirection() {
	// 	return 'row' as const
	// }

	getEditorCategory(): string {
		return 'Screen Structure'
	}
}
